$(function () {
    'use strict';

    if (typeof $.fn.magnificPopup === 'function') {
        console.log('magnificPopup is loaded');

        $('.js-preview').magnificPopup({
            type: 'image',
            // delegate: 'a',
            closeBtnInside: false,
            mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
            gallery: {
                enabled: true
            },
            image: {
                verticalFit: true
            },
            zoom: {
                enabled: true,
                duration: 300
            }
        });
    }
});

